// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RefundButton__button___ixFz1{min-height:2.5rem}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/components/refundButton/RefundButton.scss"],"names":[],"mappings":"AAAA,8BACE,iBAAA","sourcesContent":[".button {\n  min-height: 2.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "RefundButton__button___ixFz1"
};
export default ___CSS_LOADER_EXPORT___;
